import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { Reviews, Search } from "../../components";
import { getRandomItemsWithoutId, projects } from "../../data";
import PageMeta from "../../seo/PageMeta";

const Project = () => {
  const { id } = useParams();
  const [project, setProject] = useState({
    id: id,
    title: "",
    description: "",
    images: [],
    subtitle: "",
    tasks: [],
    bottomText: "",
  });
  const [filtered, setFiltered] = useState(
    getRandomItemsWithoutId(projects, id, projects.length)
  );

  useEffect(() => {
    window.scroll({ behavior: "smooth", top: 0 });
    const project = projects.filter((item) => item.id === id)[0];
    setProject(project);
    setFiltered(getRandomItemsWithoutId(projects, id, projects.length));
  }, [id]);

  const handleSearch = (e) => {
    setFiltered(e);
  };

  return (
    <>
      {project ? (
        <div className="bg-white flex flex-col items-center w-full">
          <PageMeta
            title={project.title || "Projects"}
            description={
              project.description ||
              "See recent commercial and residential cleaning projects completed by Clear Choice Cleaning Services."
            }
            path={`/projects/${id}`}
            image={project.image || "/assets/images/banners/gallery.webp"}
          />
          <div className="flex w-full justify-between max-w-screen-xl pt-[60px]  px-5 xl:px-0 flex-col lg:flex-row">
            <div className="xl:w-[66%] w-full text-black text-center xl:text-left">
              <p className="text-5xl xl:max-w-[80%] mb-[45px]">
                {project.title}
              </p>
              <p className="text-md xl:max-w-[80%] mb-5">
                {project.description}
              </p>

              <p className="text-md xl:max-w-[80%] mb-4">{project.subtitle}</p>

              <ul className="flex gap-1 flex-col list-disc pl-10 mb-10 text-left">
                {project.tasks.map((item, index) => (
                  <li key={index}>
                    <span className="font-medium">{item.task} </span>:{" "}
                    {item.description}
                  </li>
                ))}
              </ul>

              <p className="text-5xl mb-6">After Cleaning</p>

              <div className="flex gap-4 flex-wrap justify-evenly xl:justify-start pb-12">
                {project.images.map((item, index) => (
                  <img
                    src={item}
                    alt={`${project.title} ${index + 1}`}
                    className="w-[45%] md:w-[30%] h-[300px] object-cover object-right-top"
                    key={index}
                  />
                ))}
              </div>
            </div>

            <div className="relative w-full xl:w-[30%] flex flex-col items-center xl:items-start">
              <div className="w-5/6">
                <Search
                  data={projects}
                  onSearch={handleSearch}
                  filterBy="title"
                  id={id}
                />
              </div>

              <p className="text-2xl text-blue-8 mb-5 mt-10">Recent Projects</p>

              <div className="flex xl:flex-col gap-4 flex-row flex-wrap justify-between">
                {filtered.slice(0, 5).map((item, index) => (
                  <>
                    {item.id !== id && (
                      <Link
                        className="flex gap-5 items-center"
                        key={index}
                        to={`/projects/${item.id}`}
                      >
                        <img
                          src={item.images[0]}
                          alt={item.title}
                          className="h-[100px] rounded-xl shadow-black/30 shadow-lg object-cover aspect-square"
                        />
                        <p className="text-lg capitalize">{item.title}</p>
                      </Link>
                    )}
                  </>
                ))}

                <div className="mt-10 flex flex-col items-center gap-5 justify-between xl:absolute xl:bottom-0">
                  <div className="px-10 py-4 text-center bg-lightblue-4 text-lg line-height-1 rounded-[20px] font-medium shadow-black shadow-xl  relative z-10">
                    Contact us today to schedule your cleaning service and
                    experience the Clear Choice difference!
                  </div>
                  <img
                    src="/assets/images/projects/contact.png"
                    alt=""
                    className="w-[280px] "
                  />
                </div>
              </div>
            </div>
          </div>

          <Reviews />
        </div>
      ) : null}
    </>
  );
};

export default Project;
